import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import { getSectionNavHoverColor } from 'styles/helpers/getThemeStyles';
import {
  StandardMenuHeroAddress,
  StandardMenuHeroPhoneNumber,
  ownIconState,
  ownTextState
} from './StandardMenuHeroLocationInformationBlocks';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const LocationDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexFlow: 'row wrap',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    padding: '10px'
  }
}));

function LayoutLocationDetails({
  street,
  state,
  city,
  postalCode,
  phoneNumber
}) {
  return (
    <LocationDetails>
      <StandardMenuHeroAddress
        street={street}
        city={city}
        state={state}
        postalCode={postalCode}
        IconProps={{
          ownState: ownIconState()
        }}
        DetailProps={{
          ownState: ownTextState(() => ({
            fontSize: '14px',
            lineHeight: '18px'
          }))
        }}
      />
      <StandardMenuHeroPhoneNumber
        phoneNumber={phoneNumber}
        IconProps={{
          ownState: ownIconState()
        }}
        LabelProps={{
          variant: ITEM_DESCRIPTION_AND_PRICES,
          ownState: ownTextState(theme => ({
            fontSize: '14px',
            lineHeight: '18px',
            '&:hover': {
              color: getSectionNavHoverColor(theme) ?? theme.palette.mediumSoy
            }
          }))
        }}
      />
    </LocationDetails>
  );
}

LayoutLocationDetails.propTypes = {
  street: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired
};

export default LayoutLocationDetails;
